import React, { Component } from 'react';
import { Modal, Button, message } from 'antd';
import SetServerModule from './SetServerModule';
import CrcService from '../Table/CrcService';
import OtherCrcService from '../Table/OtherCrcService';
import ProManagement from '../Table/ProManagement';
import Heredity from '../Table/Heredity';
import PreFilter from '../Table/PreFilter';
import UnblindCrc from '../Table/UnblindCrc';
import ThirdParty from '../Table/ThirdParty';
import Total from '../Table/Total';

class PartModule extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modules: [
                { key: 'crcService', name: 'CRC服务', disabled: true, checked: true, hasEdit: false, content: CrcService },
                { key: 'otherCrcService', name: '其他CRC服务', disabled: false, checked: true, hasEdit: false, content: OtherCrcService },
                { key: 'proManagement', name: '项目管理', disabled: false, checked: true, hasEdit: false, content: ProManagement, remark: '项目中心数>3 时，才需要填写此模块' },
                { key: 'heredity', name: '遗传办服务', disabled: true, checked: true, hasEdit: false, optional: true, content: Heredity },
                { key: 'preFilter', name: '患者预筛服务', disabled: false, checked: false, hasEdit: false, optional: true, content: PreFilter },
                { key: 'unblindCrc', name: '非盲CRC服务', disabled: false, checked: false, hasEdit: false, optional: true , content: UnblindCrc },
                { key: 'thirdParty', name: '第三方代垫费', disabled: true, checked: true, hasEdit: false, content: ThirdParty },
            ],
            loading: false,
        }
    }

    modulesRefs = []

    componentDidMount() {
        // this.loadModules();
    }

    loadModules = (list) => {
        const { modules } = this.state;
        this.modulesRefs.length = 0;
        list.forEach((item, index) => modules[index].checked = item.checked);
        this.setState({ modules });
    }

    delete = (index) => {
        Modal.confirm({
            iconType: 'question-circle',
            title: <div style={{ marginLeft: 42 }}>确定删除此服务报价模块？</div>,
            content: '删除后，可通过“设置服务报价模块”，重新勾选添加',
            onOk: () => {
                const { modules } = this.state;
                modules[index].checked = false;
                this.setState({ modules });
            },
        });
    }

    confirm = (shouldValidate) => {
        if (!shouldValidate) {
            this.props.changeStep(-1);
        } else {
            this.props.changeStep(1);
        }
    }

    setServerModule = () => {
        const { modules } = this.state;
        this.moduleRef.show(modules);
    }

    getCotent = () => {
        const { editable, names, mode } = this.props;
        const { modules } = this.state;
        const arr = [];
        let i = 1, o = 1, idx = 0;
        modules.forEach((item, index) => {
            const { key, checked, optional, content: Dom, remark } = item;
            if (checked) {
                let title = '';
                if (optional) {
                    title = `${names.optionalPart}${ o++ }：${names[key]}`;
                } else {
                    if (names.en) {
                        title = `${names.part}${names.digits[i - 1]}：${names[key]}`;
                    } else {
                        title = `${(names.part || '').replace(/\w/, () => names.digits[i - 1])}：${names[key]}`;
                    }
                    i++;
                }
                arr.push(Dom ? <Dom ref={el => this.modulesRefs[idx++] = el} mode={mode} names={names} title={title} remark={remark} editable={editable} delete={() => this.delete(index)} /> : null);
            }
        });
        return arr;
    }

    render() {
        const { title, editable, mode, names } = this.props;
        return (
            <div>
                <h2 className="quotation-title">{title}</h2>
                { editable && <Button onClick={() => this.setServerModule()} style={{ margin: "0 10px 6px", background: '#62cf96', color: '#fff', borderColor: '#62cf96' }}>设置服务报价模块</Button> }
                { this.getCotent() }
                <Total title={names.total} mode={mode} names={names} editable={editable} />
                <SetServerModule ref={el => this.moduleRef = el} loadModules={this.loadModules} />
            </div>
        );
    }
}

export default PartModule;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Detail/Components/PartModule.js